import {externalApiURL} from '@logistics-frontend/client-core/api/corp'
import type {Optional} from '@logistics-frontend/types'
import type {
  V2FormRequest,
  V2FormResponse,
} from '@logistics-frontend/types/schemas/services/delivery-corp-account-api/definitions/delivery_form'
import {addQuery} from '@logistics-frontend/utils'

import type {
  FormOrderRequest,
  FormOrderResponse,
  GeoPoint,
  PaymentMethodsListRequest,
  PaymentMethodsListResponse,
} from 'src/shared/types'

import {toPaymentInfo} from '../../utils'
import {fetch} from '../fetch'

function fetchFormOrder(body: FormOrderRequest, country?: string): Promise<FormOrderResponse> {
  return fetch<FormOrderRequest, FormOrderResponse, FormOrderResponse>({
    method: 'POST',
    url: addQuery(externalApiURL('phoenix/dcaa/v1/form/order'), {country}),
    body,
  })
}

export function fetchDeliveryForm(body: V2FormRequest, country?: string): Promise<V2FormResponse> {
  return fetch<V2FormRequest, V2FormResponse, V2FormResponse>({
    method: 'POST',
    url: addQuery(externalApiURL('dcaa/v1/delivery/form'), {country}),
    body,
  })
}

function fetchPaymentMethods(body: PaymentMethodsListRequest, country?: string): Promise<PaymentMethodsListResponse> {
  return fetch<PaymentMethodsListRequest, PaymentMethodsListResponse, PaymentMethodsListResponse>({
    method: 'POST',
    url: addQuery(externalApiURL('cargo/v1/corp/employee/payment-methods/list'), {country}),
    body,
  })
}

export function fetchVerticals(location?: GeoPoint, country?: string): Promise<Optional<FormOrderResponse>> {
  // return import('./fetch-verticals.json').then(r => r.default as FormOrderResponse)

  if (location === undefined) {
    return Promise.resolve(undefined)
  }

  return fetchPaymentMethods(
    {
      should_return_only_selected: true,
      mode: 'employee',
    },
    country,
  )
    .then(toPaymentInfo)
    .then(paymentInfo => {
      if (paymentInfo === undefined) {
        throw new Error('Payment info is undefined')
      }

      return fetchFormOrder(
        {
          payment_info: paymentInfo,
          location,
        },
        country,
      )
    })
    .catch(() => {
      return undefined
    })
}
